// extracted by mini-css-extract-plugin
module.exports = {"Cases":"Cases_Cases__2ApUC","ImgBox":"Cases_ImgBox__1TtqO","TextBox":"Cases_TextBox__3DmPD","TextBox1":"Cases_TextBox1__3Prdn","TextBox2":"Cases_TextBox2__3mEWP"};